import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

Sentry.init({
  dsn: "https://f909c51dcb56708f40e4429a4cc3d037@o4509627549417472.ingest.us.sentry.io/4511304653471744",
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 0.2,
  tracePropagationTargets: ["localhost", "tavaresecamilo.com.br"],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    import('@sentry/react').then(({ replayIntegration }) => {
      Sentry.addIntegration(replayIntegration());
    });
  });
}

createRoot(document.getElementById("root")!).render(<App />);
